
  import { commonModule, companyModule } from '@/store/modules/store-accessor'
  import Vue from "vue";
  import { Component, Prop, Watch } from "vue-property-decorator";
  import { assigneeSearchFilter } from "@/helpers/data";
  
  @Component
  export default class AssigneeCombo extends Vue {
    selectedAssignee = null as any;
    assigneeItems = [] as any[];

    @Prop() defaultAssignee!: any; // for edit modals & add appointment in the calendar page
    @Prop({ default: true }) rightMargin!: boolean; // will set it to false in the add job modal
    @Prop({ default: true }) assigneeRequired!: boolean; // will set it to false in the add job modal
    @Prop({ default: false }) noPartners!: boolean; // offers modals

    loading = true;
    assigneeSearchFilter = assigneeSearchFilter;

    selectEntry() {
      this.$emit('update-filter', this.selectedAssignee);
    }

    isPartnersMode() {
      return !!companyModule.company?.modules?.includes('DFB_PORTAL_PARTNERS') && !this.noPartners;
    }

    findComboItemForAssignee(assignee: any, combo: any[]) {
      const name = (assignee?.name ?? "").trim();
      const id = assignee?.id;
      if (id != null && id !== "") {
        const byId = combo.find((item: any) => String(item.id) === String(id));
        if (byId) return byId;
      }
      if (name) {
        return combo.find((item: any) => (item.name ?? "").trim() === name);
      }
      return undefined;
    }

    refreshAssigneeItems() {
      if (this.isPartnersMode()) {
        const src = commonModule.personnelPartnersCombo;
        this.assigneeItems = Array.isArray(src) ? [...src] : [];
      } else {
        const src = commonModule.personnelCombo;
        this.assigneeItems = Array.isArray(src) ? [...src] : [];
      }
    }

    applyFromDefaultAssignee(emitUpdate: boolean) {
      if (!this.defaultAssignee || typeof this.defaultAssignee !== "object") {
        return;
      }
      const row = this.findComboItemForAssignee(this.defaultAssignee, this.assigneeItems);
      if (row) {
        this.selectedAssignee = row;
      } else {
        const extra =
          this.defaultAssignee.id != null && this.defaultAssignee.id !== ""
            ? {
                name: this.defaultAssignee.name,
                id: this.defaultAssignee.id,
                disabled: true,
              }
            : { name: this.defaultAssignee.name, disabled: true };
        this.assigneeItems.push(extra);
        this.selectedAssignee = extra;
      }
      if (emitUpdate) {
        this.$emit("update-filter", this.selectedAssignee);
      }
    }

    async ensureAssigneeComboLoaded() {
      if (this.isPartnersMode()) {
        await commonModule.getPersonnelPartnersCombo();
      } else {
        await commonModule.getPersonnelCombo();
      }
      this.refreshAssigneeItems();
    }

    @Watch("defaultAssignee", { deep: true })
    async onDefaultAssigneeChanged() {
      if (!this.assigneeItems.length) {
        await this.ensureAssigneeComboLoaded();
      }
      if (this.defaultAssignee && typeof this.defaultAssignee === "object") {
        this.applyFromDefaultAssignee(true);
      }
    }

    async mounted() {
      await this.ensureAssigneeComboLoaded();

      if (this.defaultAssignee && typeof this.defaultAssignee === "object") {
        this.applyFromDefaultAssignee(true);
      } else if (this.assigneeItems.length === 1) {
        this.selectedAssignee = this.assigneeItems[0];
        this.$emit("update-filter", this.selectedAssignee);
      }

      this.loading = false;
    }

    get assigneeDropdownLabel() {
      if(this.isPartnersMode()) {
        return this.$i18n.t('userPartner');
      }
      else {
        return this.$i18n.t('user');
      }
    }

    entryIcon(is_partner: boolean) {
      if(is_partner !== undefined) {
        return is_partner ? 'mdi-account-multiple' : 'mdi-account'
      }
      else {
        return 'mdi-account-off-outline'
      }
    }

    rules = [
      (val: any) => !!val || this.$i18n.t("userPartnerRequired"),
    ]

    setAssigneeRules() {
      return this.assigneeRequired ? this.rules : [];
    }

  }
